// La API manda ISO 8601 con zona. Se formatea en el navegador para que cada
// usuario vea SU hora: el producto opera en varios paises.
//
// A `Intl` no se le pasa `timeZone` a proposito: sin ese argumento aplica la
// zona del dispositivo, que es justamente la que hay que mostrar. El idioma
// queda fijo en es-AR, igual que los importes del resto del panel, para que
// el orden sea dia/mes.
//
// Lo que arma el servidor y el navegador no toca -el CSV que se descarga y el
// ticket que se imprime- sigue llegando ya escrito en la hora de la casa y no
// pasa por aca.

const ES = "es-AR";

// Un dia del calendario ("2026-10-08") no es un instante. Leerlo como fecha
// lo interpreta a medianoche UTC, y en toda America eso lo corre un dia para
// atras. Los dias se escriben tal cual, sin convertir nada.
const SOLO_DIA = /^(\d{4})-(\d{2})-(\d{2})$/;

// Solo se acepta lo que la API manda. `new Date("08/10 23:45")` no falla: lo
// lee como 10 de agosto. Un texto que no sea ISO 8601 se descarta en vez de
// mostrar otra fecha con cara de correcta.
const ISO_INSTANTE = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/;

function instante(valor) {
  if (valor instanceof Date) return Number.isNaN(valor.getTime()) ? null : valor;
  if (typeof valor !== "string") return null;
  const texto = valor.trim();
  if (!ISO_INSTANTE.test(texto)) return null;
  const fecha = new Date(texto);
  return Number.isNaN(fecha.getTime()) ? null : fecha;
}

// es-AR pide "d/M" cuando se le piden dia y mes sin año, asi que el 8 sale
// como "8" y las columnas quedan desparejas. El relleno se hace aca.
const dosDigitos = valor => String(valor).padStart(2, "0");

function diaYMes(fecha) {
  const partes = new Intl.DateTimeFormat(ES, { day: "2-digit", month: "2-digit" })
    .formatToParts(fecha)
    .reduce((acc, parte) => Object.assign(acc, { [parte.type]: parte.value }), {});
  return `${dosDigitos(partes.day)}/${dosDigitos(partes.month)}`;
}

// "08/10 23:45" — dia y hora, para una operacion puntual.
export const fechaHora = iso => {
  const dia = typeof iso === "string" ? SOLO_DIA.exec(iso.trim()) : null;
  if (dia) return `${dia[3]}/${dia[2]}`;
  const fecha = instante(iso);
  if (!fecha) return "";
  const hora = fecha.toLocaleTimeString(ES, {
    hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  });
  return `${diaYMes(fecha)} ${hora}`;
};

// "08/10/2026" — solo el dia, para lo que no tiene hora que mostrar: el alta
// de un cliente, el periodo de una liquidacion.
export const fechaCorta = iso => {
  const dia = typeof iso === "string" ? SOLO_DIA.exec(iso.trim()) : null;
  if (dia) return `${dia[3]}/${dia[2]}/${dia[1]}`;
  const fecha = instante(iso);
  if (!fecha) return "";
  return fecha.toLocaleDateString(ES, {
    day: "2-digit", month: "2-digit", year: "numeric",
  });
};

// "16/10 18:30" — cuando empieza un partido, en la hora del que mira.
//
// Vivia COPIADA en App.jsx, Agencia.jsx, Box.jsx y Web.jsx, identica en las
// cuatro, y el panel del admin no la tenia: ahi la hora se imprimia tal cual
// la manda el servidor, que la escribe en la zona de la casa (`TZ_CASA`, por
// defecto Buenos Aires). Un operador en Colombia leia que un partido empezaba
// a las 20:30 cuando para el eran las 18:30, o sea que ya habia empezado, en
// la pantalla cuya unica razon de ser es decidir a tiempo si se bloquea un
// mercado.
//
// `ev.time` queda de respaldo y nada mas, que es para lo que el backend lo
// manda: lo dice el docstring de `gr8_catalogo._hora_de_casa`. Se usa cuando
// no hay instante crudo o no se puede interpretar, no como primera opcion.
//
// No pasa por `Intl` como las de arriba a proposito: el formato `dd/MM HH:mm`
// de una lista de doscientos partidos tiene que ser el mismo en las cinco
// pantallas, y `instante()` rechaza justamente el "08/10 23:45" ya armado que
// aca llega como respaldo.
export const horaLocal = ev => {
  const crudo = ev?.commence_time || ev?.start_time;
  if (!crudo) return ev?.time || "--/-- --:--";
  const d = new Date(crudo);
  if (isNaN(d)) return ev?.time || "--/-- --:--";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm} ${hh}:${mi}`;
};
